import { useEffect, useRef, useState } from 'react';
import {
  FaFacebookF,
  FaInstagram,
  FaPinterestP,
  FaRegHeart,
  FaYoutube,
} from 'react-icons/fa';
import { IoIosArrowDown, IoIosArrowForward } from 'react-icons/io';
import { IoClose } from 'react-icons/io5';
import { RxHamburgerMenu } from 'react-icons/rx';
import {
  TbHeartPlus,
  TbSearch,
  TbShoppingCart,
  TbUserPlus,
} from 'react-icons/tb';
import { Link } from 'react-router-dom';
import logo from '../../img/logo.png';
import { headerNav } from '../../utils/constants';

const followOptions = [
  {
    icon: <FaInstagram />,
    link: 'https://www.instagram.com/gritrtx/',
  },
  {
    icon: <FaFacebookF />,
    link: 'https://www.facebook.com/gritrtexas/',
  },
  {
    icon: <FaYoutube />,
    link: 'https://www.youtube.com/@gritrtx',
  },
  {
    icon: <FaPinterestP />,
    link: 'https://www.pinterest.com/gritrtx/',
  },
];

const Header = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [isBurgerMenuOpen, setBurgerMenuOpen] = useState(false);
  const breakpoint = 1024;
  const [openAccordion, setOpenAccordion] = useState(null);
  const [isSearchActive, setSearchActive] = useState(false);
  const [searchValue, setSearchValue] = useState('');
  const searchContainerRef = useRef(null);
  const handleAccordionClick = (index) => {
    if (openAccordion === index) {
      setOpenAccordion(null);
    } else {
      setOpenAccordion(index);
    }
  };
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= breakpoint && isBurgerMenuOpen) {
        setBurgerMenuOpen(false);
      }
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [isBurgerMenuOpen]);
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        searchContainerRef.current &&
        !searchContainerRef.current.contains(e.target)
      ) {
        setSearchActive(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return (
    <div className='header-container'>
      <div className='header-top'>
        <div
          className='header-search-input-container'
          ref={searchContainerRef}
          onClick={() => setSearchActive(true)}
        >
          <input
            className='search-input'
            placeholder='Search the store'
            autoComplete='off'
            value={searchValue}
            onChange={(e) => setSearchValue(e.target.value)}
          />
          <a
            target='_blank'
            rel='noreferrer'
            href={`https://gritrgear.com/search.php?search_query=${searchValue}`}
            className='header-search-icon'
          >
            <TbSearch
              style={{
                width: '20px',
                height: '20px',
                color: isSearchActive ? '#ff641c' : '#ffffff',
                transition: 'color 0.3s ease',
              }}
            />
          </a>
        </div>
        <div
          onClick={() => setBurgerMenuOpen(!isBurgerMenuOpen)}
          className='header-mobile-left'
        >
          {isBurgerMenuOpen ? (
            <IoClose className='header-left-icon' />
          ) : (
            <RxHamburgerMenu className='header-left-icon' />
          )}
        </div>
        <div className={`mobile-menu ${isBurgerMenuOpen ? 'open' : ''}`}>
          <div className='mobile-menu-inner'>
            <div className='mobile-menu-input-search'>
              <input
                className='input-search'
                placeholder='Search the store'
                value={searchValue}
                onChange={(e) => setSearchValue(e.target.value)}
              />
              <a
                target='_blank'
                rel='noreferrer'
                href={`https://gritrgear.com/search.php?search_query=${searchValue}`}
                className='header-search-icon'
              >
                <TbSearch style={{ width: '20px', height: '20px' }} />
              </a>
            </div>
            <nav className='mobile-menu-nav'>
              {headerNav.map((h, i) => (
                <div key={`${h.name}-${i}`}>
                  <div
                    className='mobile-menu-item-header'
                    onClick={() => handleAccordionClick(i)}
                  >
                    <a href={h.link} className='mobile-menu-link'>
                      {h.name}
                    </a>
                    {h.values.length > 0 && (
                      <span className='accordion-icon'>
                        {openAccordion === i ? (
                          <IoIosArrowDown />
                        ) : (
                          <IoIosArrowForward />
                        )}
                      </span>
                    )}
                  </div>

                  {h.values.length > 0 && (
                    <div
                      className={`accordion-content ${
                        openAccordion === i ? 'open' : ''
                      }`}
                    >
                      <ul>
                        <li>
                          <a
                            href={h.link}
                            className='accordion-sublink shop-all'
                          >
                            {`Shop All ${h.name}`}
                          </a>
                        </li>
                        {h.values.map((value, j) => (
                          <li key={`${value.name}-${j}`}>
                            <a href={value.link} className='accordion-sublink'>
                              {value.name}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </div>
                  )}
                </div>
              ))}
            </nav>
            <div className='wish-list-container'>
              <FaRegHeart style={{ color: '#fff' }} />
              <a
                className='navPages-action'
                href='https://gritrgear.com/wishlist.php'
              >
                Wish Lists
              </a>
            </div>
            <div className='social-network-mobile'>
              {followOptions.map((option, index) => (
                <a
                  key={index}
                  href={option.link}
                  target='_blank'
                  rel='noopener noreferrer'
                >
                  {option.icon}
                </a>
              ))}
            </div>
          </div>
        </div>
        <a className='header-logo-link' href='https://gritrgear.com/'>
          <img src={logo} alt='logo' className='header-logo' />
        </a>
        <ul className='header-left-list'>
          <li className='header-option header-option-right'>
            <a
              href='https://gritrgear.com/account.php'
              className='header-option-link'
            >
              <TbUserPlus className='header-left-icon' />
            </a>
          </li>
          <li className='header-option header-center-icon'>
            <a
              href='https://gritrgear.com/wishlist.php'
              className='header-option-link'
            >
              <TbHeartPlus className='header-left-icon' />
            </a>
          </li>
          <li className='header-option header-option-right'>
            <a
              href='https://gritrgear.com/cart.php'
              className='header-option-link'
            >
              <TbShoppingCart className='header-left-icon' />
            </a>
          </li>
        </ul>
      </div>

      <div className='header-center' onMouseLeave={() => setOpenDropdown(null)}>
        <ul className='header-list'>
          {headerNav.map((h, i) => (
            <li
              key={`${h.name}-${i}`}
              className='header-option'
              onMouseEnter={() => setOpenDropdown(i)}
            >
              {h.type === 'internal' ? (
                <Link to={h.link} className='header-option-link'>
                  {h.name}
                </Link>
              ) : (
                <a href={h.link} className='header-option-link'>
                  {h.name}
                </a>
              )}
            </li>
          ))}
        </ul>

        {headerNav.map((h, i) =>
          h.values.length ? (
            <ul
              key={i}
              className={`header-option-list ${
                openDropdown === i ? 'open' : ''
              }`}
            >
              <div className='header-menu-section'>
                <a href={h.link} className='header-menu-link'>
                  {`Shop All ${h.name}`}
                </a>
                <ul className='header-option-list-container'>
                  {h.values.map((value, j) => (
                    <li key={j} className='header-option-item'>
                      <a className='header-menu-item' href={value.link}>
                        {value.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            </ul>
          ) : null,
        )}
      </div>
    </div>
  );
};

export default Header;
